module.exports = __webpack_public_path__ + "img/logo_GI_blu_it.e89f41a2.png";